import type { ReimbursementFilters } from '../types'

const FILTER_KEYS_TO_COUNT: Array<keyof ReimbursementFilters> = [
  // `q` is counted in `countActiveFilters` (toolbar search), same pattern as Invitee / Residents.
  // org_id is hidden from the filter drawer and should not affect the badge count.
  'companyId',
  'propertyId',
  'reimbursement_type',
  'rentalStatus',
  'defaultStatus',
  'claim_status',
  'review_decision',
  'document_status',
  'notification_fromDt',
  'lease_start_fromDt',
  'claim_status_fromDt',
]

/**
 * Counts the filter fields the user has actively narrowed (drawer + toolbar search `q` when non-empty).
 * Pagination, sort, and the always-set `past_customer` default are excluded.
 */
export function countActiveFilters(filters: ReimbursementFilters): number {
  let count = 0
  if (filters.q && String(filters.q).trim()) count += 1
  for (const key of FILTER_KEYS_TO_COUNT) {
    const value = filters[key]
    if (value === undefined || value === null || value === '') continue
    if (Array.isArray(value) && value.length === 0) continue
    count += 1
  }
  return count
}
